module.exports = __webpack_public_path__ + "static/rachel-4f1b6804216a4404125c54f129f4aa20.jpg";